const bundle_product_1 = document.getElementById('bundle-product-1');
const variant_id_1 = document.getElementById('variant-id-1');
const bundle_product_2 = document.getElementById('bundle-product-2');
const variant_id_2 = document.getElementById('variant-id-2');
const atc = document.getElementById('addToCart');
const shopPay = document.querySelector('shop-pay-wallet-button');

if (bundle_product_1 && variant_id_1) {
  bundle_product_1.addEventListener('change', function (e) {
    const option = e.target.options[e.target.selectedIndex];
    variant_id_1.value = option && option.dataset.variantId ? option.dataset.variantId : '';
    if (!bundle_product_2 && atc) {
      atc.disabled = false;
    }
  });
}

if (bundle_product_2 && variant_id_2) {
  bundle_product_2.addEventListener('change', function (e) {
    const option = e.target.options[e.target.selectedIndex];
    variant_id_2.value = option && option.dataset.variantId ? option.dataset.variantId : '';
    if (atc) {
      atc.disabled = false;
    }
  });
}

(function patchAjaxCart() {
  // Wait until Shopify + ajaxCart exist
  if (!window.Shopify || !Shopify.theme || !Shopify.theme.ajaxCart || !Shopify.theme.ajaxCart.addToCart) {
    // Try again on DOMContentLoaded as a safety
    document.addEventListener('DOMContentLoaded', patchAjaxCart, { once: true });
    return;
  }

  // Avoid patching more than once
  if (Shopify.theme.ajaxCart._bundlesPatched) return;
  Shopify.theme.ajaxCart._bundlesPatched = true;

  const originalAddToCart = Shopify.theme.ajaxCart.addToCart;

  Shopify.theme.ajaxCart.addToCart = function (addToCartForm, formContext, config, isQuickview) {
    // Only enforce this on forms that actually have bundle fields
    if (addToCartForm && addToCartForm.querySelector('.bundle')) {
      if (!addToCartForm.checkValidity()) {
        addToCartForm.reportValidity();
        return;
      }
    }

    // If valid (or not a bundle product), fall back to original behaviour
    return originalAddToCart.apply(this, arguments);
  };
})();